var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-base-root",class:{
      'm-base-top-border':_vm.showTopBorder,
      'm-base-right-border':_vm.showRightBorder,
      'm-base-bottom-border':_vm.showBottomBorder,
      'm-base-left-border':_vm.showLeftBorder}},[_vm._t("box",[_c('div',{staticClass:"m-base-box",class:{
        'm-base-padding':_vm.showPadding,
				'm-base-block':_vm.boxType=='block',
				'm-base-card':_vm.boxType=='card',
				'm-base-border-radius':_vm.showBorderRadius
				},style:({
          backgroundColor:_vm.backgroundColor,
          paddingLeft:_vm.showLeftPadding?'10px':'0px',
          paddingRight:_vm.showRightPadding?'10px':'0px',
          paddingTop:_vm.showTopPadding?'10px':'0px',
          paddingBottom:_vm.showBottomPadding?'10px':'0px'
        })},[(_vm.showHeader)?_c('div',{staticClass:"d-flex flex-row align-items-center",on:{"click":_vm.onMore}},[(_vm.icon&&_vm.showIcon)?_c('van-image',{staticClass:"m-base-icon",attrs:{"lazy-load":"","src":_vm.icon}}):_vm._e(),_c('div',{staticClass:"m-base-tit-box"},[_c('span',{staticClass:"m-base-tit"},[_vm._v(_vm._s(_vm.title))]),(_vm.subTitle)?_c('span',{staticClass:"m-base-tit2"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e()]),(_vm.showMore)?_c('span',{staticClass:"yticon icon-you"}):_vm._e()],1):_vm._e(),_vm._t("content")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }